import { asciiTextValidation } from 'framework/form';

export const customerReportRejectValidation = {
  rejectionReason: { type: 'string', required: true },
};

export const customerReportValidation = {
  periodStart: {
    type: 'date',
    required: true,
  },
  periodEnd: {
    type: 'date',
    required: true,
  },
};

export const externalReportValidation = {
  periodStart: {
    type: 'string',
    required: true,
  },
  periodEnd: {
    type: 'string',
    required: true,
  },
  externalReportLink: {
    type: 'string',
    required: true,
  },
};

const recipientValidation = {
  firstName: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  lastName: {
    type: 'string',
    required: true,
    maxSize: 255,
    ...asciiTextValidation,
  },
  email: {
    type: 'string',
    email: true,
    required: true,
  },
};

export const sendReportValidation = {
  emailSubject: {
    type: 'string',
    required: true,
  },
  emailBody: {
    type: 'string',
    required: true,
  },
};

export const recipientsValidation = {
  recipientsData: {
    type: 'array',
    required: true,
    forEach: {
      type: 'object',
      properties: {
        mainRecipients: {
          type: 'array',
          required: {
            value: true,
            when: {
              $ccRecipients: {
                notEmpty: true,
              },
              $mainRecipients: {
                empty: true,
              },
            },
          },
          forEach: {
            type: 'object',
            properties: recipientValidation,
          },
        },
        ccRecipients: {
          type: 'array',
          required: false,
          message: 'Main recipients are required',
          forEach: {
            type: 'object',
            properties: recipientValidation,
          },
        },
      },
    },
  },
};
